module.exports = __webpack_public_path__ + "static/cat.2255635a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/cat.png
// module id = 749
// module chunks = 186292428941015